// extracted by mini-css-extract-plugin
export var actionSelect = "_tf-0";